﻿function LookerSpinner() {
	console.log('spin');

	// find components w/ class name or data attribute
	let lookerFrames = document.querySelectorAll('.looker-embed iframe');

	// return if none
	if (lookerFrames == null) {
		return;
	}

	lookerFrames.forEach((el) => {
		el.parentElement.classList.add('db-loading');
	});

	console.log('lookerFrames: ', lookerFrames);

	lookerFrames.forEach((el) => {
		el.addEventListener('load', function () {
			el.parentElement.classList.remove('db-loading');
		})
	});	
}

export default LookerSpinner();